import { Fragment, useEffect, useState } from 'react';
import EfBundlesCard, { EfBundlesCardProps } from '@elem/ui/ef-bundles-card';
import { useRouter } from 'next/router';
import styles from './index.module.scss';
import { listIdObj } from './BundlesCommonConfig';
import { useLang } from '@/i18n';
import { getSolarRecommand, getSolarRecommand2 } from '@/service/solar-calculator';

export default function BundlesCommon() {
    const { locale = 'us', query } = useRouter();
    const { t } = useLang('theproduct.detail.bundle');
    const idObj1 = listIdObj[locale] || listIdObj['us'];
    const [renderKey, setRenderKey] = useState(1);
    const [priceObject, setPriceObject] = useState({}); //用于保存收集的shopify价格
    const [list, setList] = useState<EfBundlesCardProps[]>([
        {
            name: t('item1_name'),
            power: t('item1_power'),
            desc: t('item1_desc'),
            moreLink: `https://${locale}.ecoflow.com/products/delta-pro-3-portable-power-station`,
            productId: idObj1.a_productId,
            variantId: idObj1.a_variantId,
            coupon: 'DP3LAUNCH',
            couponText: '$500 OFF',
            couponTips: '*Copy code & apply it at checkout.\n*Only valid on DELTA Pro 3 stand-alone unit.',
            discountPrice: 0,
            originalPrice: 0,
            inventory: 0,
            // timeStart: '2024/06/11 10:00:00 GMT+8',
            // timeEnd: '2024/06/12 10:00:00 GMT+8',
            subs: idObj1.a_subs || [],
        },
        {
            name: t('item1_name'),
            power: t('item1_power'),
            desc: t('item1_desc'),
            moreLink: `https://${locale}.ecoflow.com/products/delta-pro-3-extra-battery`,
            productId: idObj1.b_productId,
            variantId: idObj1.b_variantId,
            discountPrice: 0,
            originalPrice: 0,
            inventory: 0,
            subs: idObj1.b_subs || [],
            buyInCart: true,
        },
        {
            name: t('item1_name'),
            power: t('item1_power'),
            desc: t('item1_desc'),
            moreLink: `https://${locale}.ecoflow.com/products/delta-pro-3-smart-home-panel-2`,
            productId: idObj1.c_productId,
            variantId: idObj1.c_variantId,
            discountPrice: 0,
            originalPrice: 0,
            inventory: 0,
            subs: idObj1.c_subs || [],
            buyInCart: true,
        },
    ]);

    useEffect(() => {
        // 发起请求
        const getItemPriceHandle = async (productId: string, variantId: string) => {
            const res = await getSolarRecommand({ productId, variantId }, locale);
            if (res?.code === '0') {
                return res.data;
            }
            return null;
        };
        // 发起请求
        const getItemPriceHandle2 = async (variantIds: string[]) => {
            const res = await getSolarRecommand2({ variantIds }, locale);
            if (res?.code === '0') {
                const list = res.data || [];
                const obj1: any = {};
                list.forEach((item: any) => {
                    obj1[`${item.productId}${item.variantId}`] = item;
                });
                return obj1;
            }
            return null;
        };
        // 请求全部
        const initAllHandle = async () => {
            let priceObject2: any = priceObject || {};
            const idArr = [];
            // 先取回接口的值(shopify的价格,图片等)
            for (let i = 0; i < list.length; i++) {
                const itemA = list[i];
                const keyA = `${itemA.productId}${itemA.variantId}`;
                // 已有值,不发起2次请求
                if (!priceObject2[keyA]) {
                    //const resA = await getItemPriceHandle(itemA.productId, itemA.variantId);
                    //priceObject2[`${itemA.productId}${itemA.variantId}`] = resA;
                    idArr.push(itemA.variantId);
                }

                const subs = itemA.subs || [];
                // 更多购买
                for (let j = 0; j < subs.length; j++) {
                    const itemB = subs[j];
                    const keyB = `${itemB.productId}${itemB.variantId}`;
                    // 已有值,不发起2次请求
                    if (!priceObject2[keyB]) {
                        idArr.push(itemB.variantId);
                        // const resB = await getItemPriceHandle(itemB.productId, itemB.variantId);
                        // priceObject2[`${itemB.productId}${itemB.variantId}`] = resB;
                    }
                }
            }
            priceObject2 = await getItemPriceHandle2(idArr);

            console.log('res1', priceObject2);
            //setPriceObject(priceObject2);
            // 拿到参数后,2次遍历改变
            const listB = JSON.parse(JSON.stringify(list));
            for (let i = 0; i < listB.length; i++) {
                const itemA = listB[i];
                const keyA = `${itemA.productId}${itemA.variantId}`;
                const objA = priceObject2[keyA];
                if (objA) {
                    itemA.img = itemA.img || objA.img;
                    itemA.discountPrice = objA.price;
                    itemA.originalPrice = objA.price;
                    itemA.inventoryQuantity = objA.inventoryQuantity || undefined;
                    itemA.link_buy = `https://${locale}.ecoflow.com/cart/${objA.variantId}:1?channel=buy_button`;
                }
                const subs = itemA.subs || [];
                // 更多购买
                for (let j = 0; j < subs.length; j++) {
                    const itemB = subs[j];
                    const keyB = `${itemB.productId}${itemB.variantId}`;
                    const objB = priceObject2[keyB];
                    if (objB) {
                        itemB.img = itemB.img || objB.img;
                        itemB.discountPrice = objB.price;
                        itemB.originalPrice = objB.price;
                        itemB.inventoryQuantity = objB.inventoryQuantity || undefined;
                    }
                }
            }
            setList(listB);
            setRenderKey(Math.random()); //拿到数据,重新渲染
        };
        initAllHandle();
    }, []);

    return (
        <div className={styles.BundlesCommon}>
            <Fragment key={renderKey}>
                <div className="BundlesCommon-in">
                    {list.map((item: EfBundlesCardProps, index: number) => {
                        return (
                            <Fragment key={item.variantId}>
                                <EfBundlesCard {...item}></EfBundlesCard>
                            </Fragment>
                        );
                    })}
                </div>
            </Fragment>
        </div>
    );
}
